module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-2",
    staticStyle: {
      "padding": "20%"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('influencer-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb34475"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/InfluencerLists/index.vue
// module id = 2222
// module chunks = 0